export default __webpack_public_path__ + "static/media/product-16 (1).a76ca3e8.jpg";